import { ILogService, IOnChangesObject, IQService, ISCEService, IScope, ITimeoutService } from 'angular'
import { FileItem } from 'angular-file-upload'
import { chain, forEach } from 'lodash'
import { Modal } from 'materialize-css'
import { BASE_CANDIDATO_API } from 'src/_candidato/comun/services/acceso-datos'
import { CVModel } from 'src/_candidato/data/cv/CVModel'
import { CVFilePreg } from 'src/_candidato/data/cv/CVResp'
import { CurriculumPrivService } from 'src/_candidato/priv/services/CurriculumPrivService'
import { $candidatoPublicMod } from 'src/_candidato/public/candidato-public-mod'
import {
  ICurriculumRequestEdit,
  IFeaturesPubl,
  IFilaCV,
  IICuestionario,
  IICuestionarioBloque,
  IICuestionarioPreg,
  IItemMenu,
  IReporteCV,
} from 'src/model/candidato-api'

class EditcvFormComponentCtrl {
  modelcv!: IFilaCV
  reportecv!: IReporteCV
  cuestionario!: IICuestionario<IICuestionarioBloque<IICuestionarioPreg>>
  menuopt!: IItemMenu
  params!: { [v: string]: any }
  appConfig!: IFeaturesPubl
  accesoPublico!: boolean

  aceptarTerminos = true
  aceptarRecaptcha = true
  modalAceptar = true

  $ready = false
  cvmodel: CVModel

  errorcapt = false
  erroraccept = false
  form = {
    recapResponse: '',
    dataaccept: false,
  }
  testCV: number = 7
  $loading = false
  $success = false
  modalInstance: Modal

  test__reqJson: unknown = null
  test__verEstruct = false
  test__verRespuestas = false

  constructor(
    private $scope: IScope,
    private $element: JQLite,
    private $timeout: ITimeoutService,
    private $q: IQService,
    private $log: ILogService,
    private vcRecaptchaService: any,
    private CurriculumPrivService: CurriculumPrivService,
    private $sce: ISCEService
  ) {}

  $onInit(): void {
    this.$log.info('[EditcvFormComponentCtrl] onInit')

    this.aceptarTerminos = false // this.appConfig.acceptTerms || this.menuopt.accLo
    this.aceptarRecaptcha = false //this.appConfig.acceptRecaptcha || this.menuopt.accRc
    this.modalAceptar = false // this.aceptarRecaptcha || this.aceptarTerminos

    // this.__init()
  }

  $onChanges(changes: IOnChangesObject) {
    if (changes.cuestionario && changes.cuestionario.currentValue) {
      this.__init()

      if (this.reportecv && !this.cvmodel.reporteEdicion) {
        this.cvmodel.paraEdicion(this.reportecv)
      }
    }

    if (changes.reportecv && changes.reportecv.currentValue && this.cvmodel && !this.cvmodel.reporteEdicion) {
      this.cvmodel.paraEdicion(changes.reportecv.currentValue)
    }
  }

  private __init() {
    this.$ready = false

    this.cvmodel = new CVModel()
    this.$success = false
    this.$loading = false
    this.erroraccept = false
    this.errorcapt = false
    this.test__reqJson = null
    this.form = {
      recapResponse: '',
      dataaccept: false,
    }

    // forzar un cambio de modelo
    this.$ready = true
  }

  $postLink() {
    this.$timeout((_) => {
      let modalInstance = this.$element.find('#modal-send').modal({
        onCloseEnd: () => $('body').removeClass('modal-open').css('overflow', 'auto'),
      })
      this.modalInstance = M.Modal.getInstance(modalInstance[0])
    }, 1000)
  }

  sendCuestionario() {
    if (!this.cvmodel.validar(true /* omitir files */)) {
      this.$log.info('Validación falla')
      return
    }

    if (this.modalAceptar) {
      if (this.aceptarRecaptcha) this.vcRecaptchaService.reload()

      this.form.dataaccept = false
      this.erroraccept = false
      this.errorcapt = false

      this.modalInstance.open()
      $('body').addClass('modal-open')
    } else {
      this.modalInstance.open()
      $('body').addClass('modal-open')

      this.resendCuestionarioConfirmed()
    }

    this.$log.debug(this.__req())
  }

  private resendCuestionarioConfirmed() {
    const gestionar_files = false
    let pregFiles = this.cvmodel.files()

    this.$loading = true
    this.CurriculumPrivService.sendCvEdit(this.modelcv, this.__req())
      .then(
        (cvStateResponse) => {
          let url = BASE_CANDIDATO_API + `api/_cv/n/${cvStateResponse.tkn}/f?_f=`

          if (gestionar_files) {
            let fd = new FormData()
            fd.append('tkn', cvStateResponse.tkn)
            fd.append('t', cvStateResponse._t)

            // al guardar, enviar todos los files
            forEach(pregFiles, (pregFile) => {
              forEach(pregFile.filesEnviar(), async (file) => {
                await this.enviafile(file, pregFile, url, fd)
              })
            })
          }

          this.$success = true
        },
        () => {
          alert('Ha habido un problema, por favor vuelva a intentarlo')

          this.form.dataaccept = false
          this.vcRecaptchaService.reload()
        }
      )
      .finally(() => {
        this.$loading = false
      })
  }

  sendCuestionarioAgree() {
    // this.vcRecaptchaService.execute();

    this.$log.info('login', this.form)

    this.erroraccept = this.aceptarTerminos && !this.form.dataaccept
    if (this.erroraccept) return

    if (this.aceptarRecaptcha) {
      var recapResponse = this.vcRecaptchaService.getResponse() // returns the string response
      this.$log.info('recaptcha', recapResponse)

      if (recapResponse == '') {
        this.errorcapt = true
        return
      }
    }

    this.resendCuestionarioConfirmed()
  }

  testSendFiles() {
    let pregFiles = this.cvmodel.files()

    let url = BASE_CANDIDATO_API + 'api/_cv/n/abc/f?idcv=' + this.testCV

    // al guardar, enviar todos los files
    forEach(pregFiles, (pregFile) => {
      forEach(pregFile.filesEnviar(), async (file) => {
        await this.enviafile(file, null, url, new FormData())

        this.$log.info('== Enviado!!!')
      })
    })
  }

  testGeneraModel() {
    this.test__reqJson = this.$sce.trustAsHtml(syntaxHighlight(this.__req()))
    console.log('---> _req', this.test__reqJson)
  }

  private enviafile(f: FileItem, cvpreg: CVFilePreg, url: string, fd: FormData) {
    let $p = this.$q.defer()

    f.url = url + encodeURI(f.file.name)
    f.formData = [fd, this._formDataPreg(cvpreg)]
    f.onComplete = () => {
      $p.resolve()
    }

    f.upload()

    return $p.promise
  }

  private _formDataPreg(cvpreg: CVFilePreg) {
    if (!cvpreg) return new FormData()

    let fd = new FormData()

    fd.append('qref', cvpreg.idqref)
    fd.append('idx', cvpreg.idx)

    return fd
  }

  private __req() {
    let req: ICurriculumRequestEdit = {
      peticion: {
        idform: this.cuestionario.infoForm.idf,
        idcv: this.modelcv.cv.idcv,
      },

      resplist: this.cvmodel.respuestasEdicion(),

      verify: '',
    }

    this.$log.info('confirm', req)

    return req
  }

  rellenaTest() {
    // para cada respuesta, rellenar valor de prueba
    this.cvmodel.__rellenaTest()
  }
}

$candidatoPublicMod.component('editcvForm', {
  bindings: {
    // empresa: "<",
    modelcv: '<',
    reportecv: '<',
    cuestionario: '<',
    params: '<',
    menuopt: '<',
    appConfig: '<',
    accesoPublico: '<',
  },
  controller: EditcvFormComponentCtrl,
  template: require('./editcv-form.component.html'),
  //templateUrl: "./editcv-form.component.html"
})

function syntaxHighlight(json: any) {
  if (typeof json != 'string') {
    json = JSON.stringify(json, undefined, 2)
  }
  json = json.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
  return json.replace(
    /("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)/g,
    function (match: string) {
      var cls = 'number'
      if (/^"/.test(match)) {
        if (/:$/.test(match)) {
          cls = 'key'
        } else {
          cls = 'string'
        }
      } else if (/true|false/.test(match)) {
        cls = 'boolean'
      } else if (/null/.test(match)) {
        cls = 'null'
      }
      return '<span class="' + cls + '">' + match + '</span>'
    }
  )
}
